<template>
  <div :style="mainStyle">
    <vue-headful
    :title="data.title"
    :head="{
        'link[rel=icon]': {href: data.favicon_uri}
    }"
    />
    <app-header v-bind:data="data"></app-header>
    <div>
      <section class="page-info set-bg" v-bind:style="{ backgroundImage: `url('${data.bg_img_url + '?v='+data.last_updated}')`}"></section>
    </div>
    <router-view v-if="!Array.isArray(data)" v-bind:data="data" v-bind:siteData="data"/>
    <app-footer v-bind:data="data"></app-footer>
  </div>
</template>

<script>



const url = process.env.ROOT_API

import Header from './components/Header.vue'
import Footer from './components/Footer.vue'
import axios from 'axios'
import moment from 'moment'
import { itemsStorage } from './main.js'

export default {
  components: {
    'app-header': Header,
    'app-footer': Footer,
  },
  data () {
    return {
      data: [],
      lastUpdate: '',
      mainStyle: "--main: #666666; --main-hover: #555555"
    }
  },
  mounted() {
    if(window.location.hostname.trim().replace(/\/+$/, '') === 'manhattan.memoshishkebab.com'
    && (window.location.pathname.trim().replace(/\/+$/, '') === '' || window.location.pathname.trim().replace(/\/+$/, '') === '/viewcart')
    ){
      // Hotjar Tracking Code
      (function(h,o,t,j,a,r){
        h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
        h._hjSettings={hjid:3706422,hjsv:6};
        a=o.getElementsByTagName('head')[0];
        r=o.createElement('script');r.async=1;
        r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
        a.appendChild(r);
      })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');
    }

		if (localStorage.last_update) {
			this.lastUpdate = localStorage.last_update
		}
		itemsStorage.$on('updateItem', (i) => {
			this.lastUpdate = localStorage.last_update
    });

    this.clearStorage()
	},
  created: function() {
    const params = {};
    if (['development', 'staging'].includes(process.env.NODE_ENV)) {
      params.hash = localStorage.getItem('dev_site_hash')
    }
    axios.get(url, {params})
    .then(response => {
      this.data = response.data.data
      localStorage.stripe_key = this.data.stripe_pub_key
      this.mainStyle = "--main: "+response.data.data.colors.primary+"; --main-hover: "+response.data.data.colors.primary_darker
    })
    .catch(err => {

    })

    this.clearStorage()
  },
  methods: {
    clearStorage: function() {
      const dateFormat = "YYYY-MM-DD HH:mm:ss";
      const now = moment();
      const lastUpdate = moment(this.lastUpdate, dateFormat);
      const duration = moment.duration(now.diff(lastUpdate));

      if(localStorage.last_update === '' || duration.asHours() > 3){
        localStorage.items = [];
        localStorage.calc = [];
        localStorage.total_items = 0;
        localStorage.total_amount = 0;
        localStorage.last_update = moment()
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/App.vue